import { api } from "@/lib/api";

import type {
  CreateRiderReq,
  Rider,
  RiderList,
  UpdateRiderReq,
} from "@artisancode/api-types";

export interface RiderListParams {
  page?: number;
  per_page?: number;
  q?: string;
  is_active?: boolean;
  workspace_id?: string;
}

export const riderService = {
  list: (params?: RiderListParams) =>
    api.get<RiderList>(
      "/riders",
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateRiderReq) => api.post<Rider>("/riders", body),

  update: (id: string, body: UpdateRiderReq) =>
    api.put<Rider>(`/riders/${id}`, body),

  delete: (id: string) => api.del(`/riders/${id}`),
};
